/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Tlm_0Inputs */

const en_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`target_platforms`)
};

const ar_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المنصات المستهدفة`)
};

const bn_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`target_platforms`)
};

const de_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielplattformen`)
};

const es_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plataformas_destino`)
};

const fr_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plates-formes_cibles`)
};

const pt_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`plataformas_de_alvo`)
};

const zh_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标平台`)
};

const tr_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`target_platforms`)
};

const ru_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`целевые_платформы`)
};

const pl_svc_mobile_app_development_tlm_0 = /** @type {(inputs: Svc_Mobile_App_Development_Tlm_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`platformy_docelowe`)
};

/**
* | output |
* | --- |
* | "target_platforms" |
*
* @param {Svc_Mobile_App_Development_Tlm_0Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_tlm_0 = /** @type {((inputs?: Svc_Mobile_App_Development_Tlm_0Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Tlm_0Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "de") return de_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "es") return es_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_tlm_0(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_tlm_0(inputs)
	return en_svc_mobile_app_development_tlm_0(inputs)
});
export { svc_mobile_app_development_tlm_0 as "svc_mobile-app-development_tlm_0" }